import { render } from "./AddOurPartners.vue?vue&type=template&id=3a4e6c54"
import script from "./AddOurPartners.vue?vue&type=script&lang=js"
export * from "./AddOurPartners.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__